import { SidebarProvider } from '@ibsys/kit';
import React, { CSSProperties, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import { type RouteConfig } from '@/shared/lib/ts-router';
import { AppSidebar } from './AppSidebar/AppSideBar';
import { CopilotProvider } from '@/features/copilot';
import { MainHeader } from '@/widgets/MainLayout/ui/MainHeader/MainHeader';
import { useMainLayout } from '@/shared/ui';
import { SIDEBAR_PROVIDER_ID } from '@/widgets/MainLayout/model/constants';

type Props = PropsWithChildren<{
  menuItems: RouteConfig[];
}>;

export const MainLayout: React.FC<Props> = ({ menuItems, children }) => {
  const {
    sidebar: { activePanel, copilotWidth, isOpen, setIsOpen },
  } = useMainLayout();

  const getStyles = () => {
    // В свёрнутом состоянии показывается только одна колонка (панель навигации с кнопками
    // ИИ-агента наверху, см. CollapsedAiActions) — ширина рассчитана под неё одну, а не под
    // PanelsBar + контент вместе, как было раньше.
    const icon = '48px';
    const staticWidth = activePanel === 'navigation' ? '320px' : `${copilotWidth}px`;
    const sidebarWidth = 'var(--sidebar-width-temp, var(--sidebar-width-static))';

    return {
      ['--sidebar-width-icon']: icon,
      ['--sidebar-width-static']: staticWidth,
      ['--sidebar-width']: sidebarWidth,
      ['--sidebar-width-mobile']: '100vw',
    } as CSSProperties;
  };

  return (
    <CopilotProvider>
      <SidebarProvider
        allowShortcut={false}
        className={'h-dvh overflow-hidden'}
        id={SIDEBAR_PROVIDER_ID}
        style={getStyles()}
        open={isOpen}
        onOpenChange={setIsOpen}
      >
        <div className={'flex h-dvh overflow-hidden w-full'}>
          <AppSidebar menuItems={menuItems} style={getStyles()} />
          <main className={'bg-background grid grid-rows-[auto_1fr] w-full h-dvh overflow-hidden text-foreground'}>
            <MainHeader menuItems={menuItems} />
            <div className={'z-0 flex flex-1 flex-col overflow-hidden w-full'}>{children || <Outlet />}</div>
          </main>
        </div>
      </SidebarProvider>
    </CopilotProvider>
  );
};
